import React from 'react';

import { makeStyles, Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
}));
export default ({ value, onClick }) => {
  const classes = useStyles();
  const mailto = `mailto:${value}`;

  if (onClick) {
    return (
      <Button variant="text" className={classes.link} onClick={onClick}>
        {value}
      </Button>
    );
  }

  return (
    <a className={classes.link} href={mailto}>
      {value}
    </a>
  );
};
